import { usePortalGetTrafficDailyCount } from '@apps-common/apis/portal/unit'
import { commonIcons } from '@apps-common/config/icons'
import { CARD_RADIUS_STYLES } from '@apps-common/config/styles'
import { useNavigation } from '@apps-common/hooks/useNavigation'
import { useWindowDimensions } from '@apps-common/hooks/useWindowDimensions'
import { IUnitGenericDetailsModel } from '@apps-common/types/portal/unit'
import { ROUTE_UNIT_EVENTS } from '@apps-radionet-portal/config/private-routes'
import classNames from 'classnames'
import { EventsKpiCardSkeleton } from './EventsKpiCardSkeleton'

interface IProps {
  unit?: IUnitGenericDetailsModel
}

export const EventsKpiCard: React.FC<IProps> = ({ unit }) => {
  const { navigateForward } = useNavigation()
  const { status, unitId } = unit || {}
  const { isMobile, isMobileLg } = useWindowDimensions()

  const { isLoading, isRefetching, isError, data } = usePortalGetTrafficDailyCount({
    config: {
      enabled: !!unit && (isMobile || isMobileLg)
    },
    status: status || '',
    id: unitId || ''
  })

  const navigateEvents = () => navigateForward({ routeUrl: ROUTE_UNIT_EVENTS.buildPath(status, unitId), route: ROUTE_UNIT_EVENTS })

  const loading = !unit || !data || isLoading || isRefetching || isError

  return (
    <>
      {loading && <EventsKpiCardSkeleton />}
      {!loading && (
        <button
          type='button'
          className={classNames(
            'relative w-full flex flex-col shadow-sm bg-surface border border-border px-4 py-4',
            CARD_RADIUS_STYLES,
            loading && 'opacity-50 hover:cursor-default'
          )}
          onClick={() => {
            if (loading) return

            navigateEvents()
          }}
        >
          <div className='w-full h-full flex flex-col items-center justify-center'>
            <div className='w-full flex'>
              <div className='relative rounded-3xl mx-auto bg-surface-2 p-4 min-w-[80%]'>
                <div className='absolute right-[-5px] top-[-5px] z-[2] p-[5px] rounded-full bg-brand text-on-brand'>
                  <commonIcons.eventList className='text-[0.9rem]' />
                </div>
                <div className='flex flex-col items-center justify-center gap-2 text-text'>
                  <div className='bg-text-muted/20 min-w-[60px] text-[1.1rem] flex items-center justify-center gap-2 px-3 rounded-full'>
                    {data?.resultCount || 0}
                  </div>
                  <div className='text-[0.75rem]'>Events Today</div>
                </div>
              </div>
            </div>
            <div className='w-full flex items-center justify-between text-[0.85em] jost text-text px-2 mt-2'>
              <p>All Events</p>
              <div className='flex items-center justify-center p-1 rounded-full bg-surface-2'>
                <commonIcons.arrowAngled />
              </div>
            </div>
          </div>
        </button>
      )}
    </>
  )
}
